import 'regenerator-runtime/runtime';
import 'intl';

import React from 'react';
import { render } from 'react-dom';

import './index.scss';

import configureStore from './store/configureStore';
import Root from './root';

const store = configureStore();

const renderApp = Comp => {
  render(
    <Comp store={store} />,
    document.getElementById('root'),
  );
};

renderApp(Root);

// Hot Module Replacement
// if (module.hot) {
//   module.hot.accept('./root', () => {
//     const NextApp = require('./root').default; // eslint-disable-line
//     renderApp(NextApp);
//   });
// }
